var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2Clubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000031913998537618335690000010147045185628894137_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.7 C309.5,6.5,302.9,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.1,287.4c0,18.1,5,36.1,6.7,41.8c0.3,0.9-0.4,1.8-1.4,1.8h-54.3c-1,0-1.7-0.9-1.4-1.8c1.7-5.7,6.7-24,6.7-41.8 c-7.2,5.2-15.5,7.9-24.7,7.9c-26.6,0-49.7-22.3-48-49.3c0.9-15.2,10.6-28.2,23.4-36.2c12.9-8.1,24.9-8.7,35.6-6.1 c-6.8-8.1-11-18.6-11-30c0-28.7,26-51.4,55.8-45.6c18.6,3.6,33.4,18.9,36.5,37.6c2.4,14.5-1.9,28-10.3,38 c10.8-2.6,22.8-1.9,35.8,6.3c12.8,8.1,22.4,21.1,23.3,36.2c1.6,26.9-21.6,49.1-48.2,49.1C194.7,295.2,186.1,292.5,179.1,287.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9,114.4l7.3-7.3H33.6c-4,0-7.3,3.3-7.3,7.3s3.3,7.3,7.3,7.3h43.7c4,0,7.3-3.3,7.3-7.3v-7.3c0-4-3.3-7.3-7.3-7.3 s-7.3,3.3-7.3,7.3V114.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6,65.2l1.9-2.3l0.5-0.7c11.7-17.6-0.1-42.1-21.2-42.4h-0.5c-16.1,0-29.1,13-29.1,29.1c0,4,3.3,7.3,7.3,7.3 s7.3-3.3,7.3-7.3c0-8,6.5-14.6,14.6-14.6h0.4c9.2,0.2,14.7,11.5,9.2,19.8l6.1,4l-5.6-4.7l-1.9,2.3c-14.3,17-26.6,35.6-36.5,55.4 c-1.8,3.6-0.3,8,3.3,9.8c3.6,1.8,8,0.3,9.8-3.3C49.4,98.9,61,81.2,74.6,65.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.1,370.5c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S290.1,350.1,290.1,370.5z  M253.3,340c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4s30.4-13.6,30.4-30.4S270.1,340,253.3,340z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278,363.7c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C272.3,351.5,278,357.1,278,363.7z M273,363.7c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C269.5,371.2,273,367.9,273,363.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.3,386.7c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C259.3,380.4,262.3,383.2,262.3,386.7z  M258.1,386.7c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C256.9,389.3,258.1,388.2,258.1,386.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5,359.9c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C248.4,361.1,247.1,359.9,245.5,359.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.6,379.8c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S237.2,379.8,235.6,379.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M271.3,383.5c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C274.3,384.8,272.9,383.5,271.3,383.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 253.3,
    cy: 370.5,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047043368098043007370000009825279647271345033_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047043368098043007370000009825279647271345033_)"
    },
    d: "M242.7,350.7 c-0.2,3.5-3.4,6.2-7.2,6c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C240,344.2,242.9,347.3,242.7,350.7z M238.5,350.5 c0.1-1.4-1-2.6-2.5-2.7c-1.5-0.1-2.7,1-2.8,2.4c-0.1,1.4,1,2.6,2.5,2.7C237.2,353,238.4,351.9,238.5,350.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2Clubs);
export default __webpack_public_path__ + "static/media/card_2-clubs.6e508e1ed1cf244c6839c5469093d1aa.svg";
export { ForwardRef as ReactComponent };